import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeObj: {},
  filterObj: {},
  selectedLeaf:{},
};

export const objSlice = createSlice({
  name: "obj",
  initialState,
  reducers: {
    setActiveObj: (state, action) => {
      const { key, data } = action.payload;
      state.activeObj[key] = data;
    },
    setFilterObj: (state, action) => {
      state.filterObj = action.payload;
    },
     setSelectedLeafObj: (state, action) => {
      state.selectedLeaf = action.payload;
    },
    cleanFilterObj: (state) => {
      state.filterObj = initialState.filterObj; 
    },
     cleanSelectedLeafObj: (state) => {
      state.selectedLeaf = initialState.filterObj; 
    },

    clearObj: () => {
      return { ...initialState };
    },
  },
});

export default objSlice.reducer;
export const { setActiveObj, clearObj, setFilterObj,cleanFilterObj,setSelectedLeafObj,cleanSelectedLeafObj } = objSlice.actions;
